export default __webpack_public_path__ + "static/connect-illustration-54bc8972cb76b62ecbc325ddf4b8bdf5.svg";